import {
  Flex,
  IconButton,
  Show,
  HStack,
  FlexProps,
  SkeletonCircle,
  useDisclosure,
  Tooltip,
  Hide,
  Box,
  Image,
} from '@chakra-ui/react'
import { Trans, useLingui } from '@lingui/react/macro'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectAppState } from '../../store/selectors'
import { SettingIcon } from '../Icons/Icons'
import HamburgerIcon from '../../assets/more.png'
import { colors } from '../../theme/cssVariables'

import PSkeleton from '../Skeleton'
import UserLoginBox, { LogOut } from './UserLoginBox'

import SocialIcons, { EmailIconLink } from './SocialIcons'
import Settings from '../Settings'
import LogoBeta from './LogoBeta'

const Header = (props: FlexProps) => {
  const { isLoadedHeader } = useSelector(selectAppState)
  const isLoading = useMemo(() => {
    return !isLoadedHeader
  }, [isLoadedHeader])
  const {
    isOpen: isOpenSettings,
    onClose: onCloseSettings,
    onOpen: onOpenSettings,
  } = useDisclosure()
  const { isOpen: isOpenDrawer, onClose: onCloseDrawer, onOpen: onOpenDrawer } = useDisclosure()
  const btnRef = React.useRef(null)

  return (
    <>
      {/* 主 Header */}
      <Flex
        as="header"
        alignItems={'center'}
        justifyContent={'space-between'}
        px={'30px'}
        py={'24px'}
        boxShadow="sm"
        className="header-container"
        {...props}
      >
        {/* 左侧：Logo + 导航（桌面端） */}
        <HStack spacing="10px" alignItems={'center'}>
          {/* Logo 置灰但可见 */}
          <LogoBeta isLoading={isLoading} height={'inherit'} mr={5} />
          {/* <Show breakpoint="(max-width: 1260px)">
            <Box
              cursor={'pointer'}
              fontSize="24px"
              stroke={colors.colorB2}
              ref={btnRef}
              onClick={onOpenDrawer}
              width={'24px'}
              height={'24px'}
              className="hamburger-icon"
            >
              <Image src={HamburgerIcon} alt="Hamburger Icon" width={'100%'} height={'100%'} />
            </Box>
          </Show> */}
        </HStack>

        {/* 右侧：社交图标 + 设置 + 用户信息 */}
        <HStack justifyContent="space-between" gap={[2, '30px']} height={'100%'}>
          {/* 社交图标（桌面端） */}
          {/* <Show breakpoint="(min-width: 1261px)">
            <SocialIcons />
          </Show> */}
          {/* 用户信息 */}
          {isLoading ? (
            <PSkeleton height="30px" width="80px" borderRadius="md" />
          ) : (
            <UserLoginBox />
          )}
          {/* <Show above="sm">
            {isLoading ? (
              <SkeletonCircle size="8" startColor="#2766ad7c" endColor="#141225" />
            ) : (
              <Tooltip label={<Trans>Setting</Trans>}>
                <IconButton
                  aria-label="Settings"
                  icon={<SettingIcon size={24} />}
                  variant="icon"
                  onClick={onOpenSettings}
                />
              </Tooltip>
            )}
            
          </Show> */}
          <Tooltip label={<Trans>Setting</Trans>}>
            <IconButton
              aria-label={''}
              icon={<SettingIcon size={24} />}
              variant="icon"
              onClick={onOpenSettings}
            />
          </Tooltip>
          <LogOut />
        </HStack>
        {isOpenSettings && <Settings onClose={onCloseSettings} />}
        {/* 
        <Hide breakpoint="(min-width: 1261px)">
          <MobileDrawer
            isOpen={isOpenDrawer}
            onClose={onCloseDrawer}
            isLoading={isLoading}
            onOpenSettings={() => {
              onCloseDrawer()
              onOpenSettings()
            }}
            btnRef={btnRef}
            isRushB={true}
          />
        </Hide> */}
      </Flex>
    </>
  )
}

export default Header
